// Seeded conversion-source UUIDs the frontend uses as defaults or fallbacks.
// Mirrors the backend's lib/constants/conversion.constants.js CONVERSION_SOURCES;
// sources themselves are data (rows in conversionSources), so only ids that act
// as hardwired defaults belong here.

export const DEFRA_GHG_CONVERSION_SOURCE_ID = '5c7f57de-5209-4851-bd5e-eb1bb0e5273c'
export const DEFRA_SPEND_CONVERSION_SOURCE_ID = '54689eb6-608e-41f7-84d8-c76974d55550'
